export default {
  name: "Loading",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M16 30C8.28 30 2 23.72 2 16c0-2.46.65-4.88 1.87-7 .28-.48.89-.64 1.37-.37.48.28.64.89.36 1.37C4.56 11.82 4 13.89 4 16c0 6.62 5.38 12 12 12s12-5.38 12-12S22.62 4 16 4c-.55 0-1-.45-1-1s.45-1 1-1c7.72 0 14 6.28 14 14s-6.28 14-14 14z",
  },
}
